/* eslint-disable camelcase */
import { getTeamLabelByNumber } from '../../utils/utils'

export default {
  // 'this' - $store
  byActionType: {
    numberOfPlayersChangeEvents ({ extra: { team1, team2 } }) {
      if (!team1 || !team2) return

      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })
    }
  },
  // 'this' - $store
  byEventType: {
    'INNER_SYNC_EVENT' ({ GamePeriod, ScoreHome, ScoreAway, extra: { team1, team2, is_shootout } }) {
      const { getMatchPeriods } = this
      const { [GamePeriod]: currentPeriod } = getMatchPeriods
      const { overriddenType } = currentPeriod

      if (!team1 || !team2) return

      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })

      if (
        !is_shootout ||
        (overriddenType && overriddenType === 'shootout')
      ) return

      this.setPeriod({ GamePeriod: GamePeriod, ScoreHome, ScoreAway })
    },
    'LEFT_SIDE_TEAM' ({ TeamNumber }) {
      this.setIngameProperty({
        property: 'leftSideTeam',
        value: TeamNumber
      })
    },
    'START_PERIOD' ({ GamePeriod, extra: { team1, team2 } }) {
      if (GamePeriod === 1) return

      const { getIngameData } = this
      const { leftSideTeam } = getIngameData

      this.setIngameProperty({
        property: 'leftSideTeam',
        value: leftSideTeam === 1 ? 2 : 1
      })

      if (!team1 || !team2) return

      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })
    },
    'START_OVERTIME_PERIOD' ({ extra: { team1, team2 } }) {
      const { getIngameData } = this
      const { leftSideTeam } = getIngameData

      this.setIngameProperty({
        property: 'leftSideTeam',
        value: leftSideTeam === 1 ? 2 : 1
      })

      if (!team1 || !team2) return

      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })
    },
    'GOAL' (event) {
      const { GamePeriod, TeamNumber } = event
      const { getMatchPeriods } = this
      const { overriddenType } = getMatchPeriods[GamePeriod]
      const isShootoutPeriod = overriddenType === 'shootout'

      if (isShootoutPeriod) {
        this.updateShootoutStatistic({
          team: getTeamLabelByNumber(TeamNumber),
          value: true
        })
      } else {
        this.setScore(event)
      }
    },
    'FREE_THROW_MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })
    },
    'FINISH_OVERTIME_PERIOD' (event) {
      const { getMatchPeriods } = this
      const { extra: { is_shootout, team1, team2 }, GamePeriod } = event
      const { [GamePeriod]: currentPeriod } = getMatchPeriods
      const { overriddenType } = currentPeriod

      if (!team1 || !team2) return

      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })

      if (
        !is_shootout ||
        (overriddenType && overriddenType === 'shootout')
      ) return

      this.setPeriod({ GamePeriod: event.GamePeriod + 1, ScoreHome: event.ScoreHome, ScoreAway: event.ScoreAway })
      this.setPenaltyShootouts({ GamePeriod: event.GamePeriod + 1 })
    },
    'FINISH_PERIOD' (event) {
      const { getMatchPeriods } = this
      const { extra: { is_shootout }, GamePeriod } = event
      const { [GamePeriod]: currentPeriod } = getMatchPeriods
      const { overriddenType } = currentPeriod

      this.setTimer(event)

      if (
        !is_shootout ||
        (overriddenType && overriddenType === 'shootout')
      ) return

      this.setPenaltyShootouts(event)
    },
    'START_SHOOTOUT' (event) {
      this.setPenaltyShootouts(event)
    },
    'SHOOTOUT_MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })
    },
    'CANCEL' (event) {
      const { RelatedEventNumber } = event
      const { getEventCache, getCurrentPeriod, getMatchPeriods } = this
      const relatedEvent = getEventCache[RelatedEventNumber]
      const { EventCode, TeamNumber, extra: { team1, team2, is_shootout } } = relatedEvent
      const { overriddenType } = getMatchPeriods[getCurrentPeriod]
      const isShootoutPeriod = overriddenType === 'shootout'

      if (['GOAL', 'FREE_THROW_MISS', 'SHOOTOUT_MISS'].includes(EventCode) && isShootoutPeriod) {
        this.updateShootoutStatistic({
          team: getTeamLabelByNumber(TeamNumber),
          type: 'delete'
        })
      }

      if (EventCode === 'START_SHOOTOUT' || is_shootout) {
        this.deletePenaltyShootoutFlag(getCurrentPeriod)
        this.clearShootoutFlag()
        this.setEventLogPeriod(getCurrentPeriod)
        this.setStatisticPeriod(getCurrentPeriod)
      }

      if (EventCode === 'START_OVERTIME_PERIOD' && team1 && team2) {
        this.setIngameProperty({
          property: 'playersCount',
          value: {
            home: team1,
            away: team2
          }
        })
      }

      this.setScore(event)
      this.setCanceled(event)
      this.refreshDelayedEvents(event)
    },
    'PENALTY_FINISH' (event) {
      this.editPeriodScore(event)
    },
    'FINISH_GAME' (event) {
      const { sport } = this
      const { customVictoryTitle } = sport.methods

      this.setWinner(event)

      if (customVictoryTitle) {
        const getcustomVictoryTitle = customVictoryTitle.bind(this)

        this.setCustomVictoryTitle(getcustomVictoryTitle(event))
      }
    }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
    'ADJUST_POINTS' () {
      return this.$t('hockey.adjust.points')
    },
    'FACE_OFF' (event) {
      if (!event.eventInfo) return ''

      const { extra: { point } } = event

      return `${event.eventInfo.title} / ${this.$t('hockey.face.off.point')}: ${point}`
    },
    /**
     * @return {string}
     */
    'POSESSION_1' (event) {
      const { GamePeriod } = event
      const { getMatchPeriods, homeTeamTitle } = this
      const { overriddenType } = getMatchPeriods[GamePeriod]

      if (overriddenType === 'shootout') {
        return `${this.$t('water_polo.shootout.possession.title')} / ${homeTeamTitle}`
      }

      if (!event.eventInfo) return ''

      return `${event.eventInfo.title} / ${homeTeamTitle}`
    },
    /**
     * @return {string}
     */
    'POSESSION_2' (event) {
      const { GamePeriod } = event
      const { getMatchPeriods, awayTeamTitle } = this
      const { overriddenType } = getMatchPeriods[GamePeriod]

      if (overriddenType === 'shootout') {
        return `${this.$t('hockey.shootout.possession.title')} / ${awayTeamTitle}`
      }

      if (!event.eventInfo) return ''

      return `${event.eventInfo.title} / ${awayTeamTitle}`
    },
    /**
     * @return {string}
     */
    'FINISH_GAME' (event) {
      const { GamePeriod } = event
      const { getMatchPeriods, homeTeamTitle, awayTeamTitle, getWinner } = this
      const { type, overriddenType } = getMatchPeriods[GamePeriod]
      const teamTitle = getWinner === 'home' ? homeTeamTitle : awayTeamTitle

      if (getWinner === 'draft') {
        return `${this.$t('trader.gameover')} / ${this.$t('trader.draw.capitalized')}`
      }

      if (overriddenType === 'shootout') {
        return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.bullets')}`
      }

      if (type === 'overtime') {
        return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.overtime')}`
      }

      return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.maintime')}`
    }
  },
  eventClasses: {
    /**
     * @return {string}
     */
    'ADDITIONAL_TIME' ({ extra: { minutes } }) {
      if (!minutes) return ''

      return '_green'
    }
  },
  customVictoryTitle (event) {
    const { GamePeriod } = event
    const { getMatchPeriods, getWinner } = this

    if (getWinner === 'draft') return

    const { type, overriddenType } = getMatchPeriods[GamePeriod]

    if (overriddenType === 'shootout') return this.$t('trader.win.throws')

    if (type === 'overtime') return this.$t('trader.win.overtime')

    return this.$t('trader.win.maintime')
  }
}
